// extracted by mini-css-extract-plugin
module.exports = {"thanks":"thanks--2lbnBd","image":"image--3eEMTA","link":"link--2tbJJH","survey":"survey--N7oCov"};